import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Enlist.css';
import Navbar from '../components/Navbar';
import apiClient from '../utils/apiClient';

const Enlist = () => {
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    wechat: '',
    email: '',
    status: '',
    statusDescription: '',
    age: '',
    workplace: '',
    hoursPerWeek: 3,
    gameMemories: '',
    motivation: '',
    additionalInfo: '',
    photoshopSkill: 3,
    englishSkill: 3,
    japaneseSkill: 3,
    englishInternetHabit: 3,
    emulatorExperience: 3
  });

  // Slider labels for different skill types
  const skillLevelLabels = {
    photoshop: ['没用过', '用过一点', '偶尔使用', '经常使用', '日常使用'],
    english: ['不会', '能看懂一些', '基本够用', '比较流利', '接近母语'],
    japanese: ['不会', '能看懂一些', '基本够用', '比较流利', '接近母语'],
    internet: ['没有', '很少', '偶尔', '经常', '主要使用英文网络'],
    emulator: ['没用过', '下载过游戏包', '会自己搜寻游戏', '会自己配置', '很熟悉配置']
  };
  
  // Current step in the character creation process (0 = mission intro)
  const [currentStep, setCurrentStep] = useState(0);
  
  // Mission description expanded state (removed - now always shown as step 0)
  
  // Reference for the character stats radar chart
  // eslint-disable-next-line no-unused-vars
  const chartRef = useRef(null);
  
  // Sound effects
  // eslint-disable-next-line no-unused-vars
  const [isSoundEnabled, setIsSoundEnabled] = useState(false);
  const clickSound = useRef(null);
  const successSound = useRef(null);
  
  // Play sound effect with volume control
  const playSound = (sound) => {
    // Sound functionality disabled due to missing files
    // If sound files were available, we would use this code:
    // if (isSoundEnabled && sound.current) {
    //   sound.current.volume = 0.3;
    //   sound.current.currentTime = 0;
    //   sound.current.play().catch(e => console.error('Error playing sound:', e));
    // }
  };
  
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  // Navigate to next step
  const nextStep = () => {
    playSound(clickSound);
    setCurrentStep(prev => {
      console.log('Moving from step', prev, 'to step', prev + 1);
      return prev + 1;
    });
  };
  
  // Navigate to previous step
  const prevStep = () => {
    playSound(clickSound);
    setCurrentStep(prev => prev - 1);
  };
  
  // Removed toggleMission - mission is now step 0
  
  // Handle form submission
  const handleSubmit = async () => {
    playSound(successSound);
    
    console.log('Form submission triggered at step:', currentStep);
    
    try {
      // Send data to backend
      const response = await apiClient.post('/volunteer-applications', formData);
      console.log('Application submitted successfully:', response.data);
      
      // Go to success step
      nextStep();
    } catch (error) {
      console.error('Error submitting application:', error);
      alert('提交申请时出错，请稍后重试。');
    }
  };
  
  // Check if current step is complete and can proceed
  const isStepComplete = () => {
    switch(currentStep) {
      case 0: // Mission intro - always complete
        return true;
      case 1: // Basic info
        return formData.name && formData.email;
      case 2: // Status and availability
        if (formData.status === 'other') {
          return formData.status && formData.statusDescription && formData.age && formData.hoursPerWeek;
        }
        return formData.status && formData.age && formData.hoursPerWeek;
      case 3: // Game memories and motivation
        return formData.gameMemories && formData.motivation;
      case 4: // Skills sliders - always complete
        return true;
      default:
        return true;
    }
  };
  
  // Render the current step
  const renderStep = () => {
    switch(currentStep) {
      case 0:
        return (
          <div className="character-creation-step mission-intro-step">
            <h2 className="step-title">关于我们</h2>
            <div className="mission-intro-content">
              <p>怀旧游戏博物馆的运营已经进入第三年了。自创立之初，我们希望跨时间和地域的游戏能被更多人接触到：也因此，过去两年间，馆内所有游戏均完成了对浏览器可玩的适配，但由于系统限制，每个游戏的调试都需要复杂的配置流程。经过接近一年的开发，我们建立了一个统一的游戏档案和模拟系统，只需填写几个参数即可完成游戏配置与联机设置。</p>
              <p>如今，我们希望建立一个不求规模庞大，但内容资料完整的可玩游戏库，以保证每一个条目不仅能被怀旧玩家检索到，更能被新玩家所理解。这也将会支持我们在下一步的工作里，不止让老游戏可以玩，也让他们的文化语境和公共记忆可以被更好的传递。我们的初衷是希望电子游戏可以更多被理解而不是被恐惧，而玩家们也可以在这里找到自己的，和别人的游戏乡愁。</p>
              <p>谢谢你有兴趣成为我们的一份子！</p>
            </div>
          </div>
        );
      
      case 1:
        return (
          <div className="character-creation-step">
            <h2 className="step-title">基本信息</h2>
            <div className="form-group">
              <label>姓名</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="请输入你的名字"
                className="rpg-input"
                required
              />
            </div>
            <div className="form-group">
              <label>微信号或手机号</label>
              <input
                type="text"
                name="wechat"
                value={formData.wechat}
                onChange={handleChange}
                placeholder="请输入你的微信号或手机号"
                className="rpg-input"
              />
            </div>
            <div className="form-group">
              <label>电子邮箱</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="请输入你的电子邮箱"
                className="rpg-input"
                required
              />
            </div>
          </div>
        );
      
      case 2:
        return (
          <div className="character-creation-step">
            <h2 className="step-title">当前状态与时间</h2>
            <div className="form-group">
              <label>当前状态</label>
              <div className="status-options">
                <div 
                  className={`status-option ${formData.status === 'student' ? 'selected' : ''}`}
                  onClick={() => handleChange({ target: { name: 'status', value: 'student' } })}
                >
                  <div className="status-icon student-icon"></div>
                  <span>学生</span>
                </div>
                <div 
                  className={`status-option ${formData.status === 'working' ? 'selected' : ''}`}
                  onClick={() => handleChange({ target: { name: 'status', value: 'working' } })}
                >
                  <div className="status-icon working-icon"></div>
                  <span>在职</span>
                </div>
                <div 
                  className={`status-option ${formData.status === 'other' ? 'selected' : ''}`}
                  onClick={() => handleChange({ target: { name: 'status', value: 'other' } })}
                >
                  <div className="status-icon other-icon"></div>
                  <span>其他</span>
                </div>
              </div>
            </div>
            
            {formData.status === 'other' && (
              <div className="form-group">
                <label>请描述状态</label>
                <input
                  type="text"
                  name="statusDescription"
                  value={formData.statusDescription}
                  onChange={handleChange}
                  placeholder="请简单描述你的当前状态"
                  className="rpg-input"
                  required
                />
              </div>
            )}
            
            {formData.status && (
              <>
                <div className="form-group">
                  <label>年龄</label>
                  <input
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    placeholder="请输入你的年龄"
                    className="rpg-input"
                    min="1"
                    max="120"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>所在地</label>
                  <input
                    type="text"
                    name="workplace"
                    value={formData.workplace}
                    onChange={handleChange}
                    placeholder={formData.status === 'student' ? "就读院校" : formData.status === 'working' ? "工作单位" : "当前所在"}
                    className="rpg-input"
                  />
                </div>
                <div className="form-group">
                  <label>意向投入多少时间</label>
                  <div className="slider-container">
                    <input
                      type="range"
                      name="hoursPerWeek"
                      min="0"
                      max="7"
                      value={formData.hoursPerWeek}
                      onChange={handleChange}
                      className="rpg-slider"
                    />
                    <div className="slider-value">{formData.hoursPerWeek} 小时/周</div>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      
      case 3:
        return (
          <div className="character-creation-step">
            <h2 className="step-title">关于你与游戏</h2>
            <div className="form-group">
              <label>你喜欢的游戏有哪些？有什么忘不掉的游戏回忆可以分享吗？</label>
              <textarea
                name="gameMemories"
                value={formData.gameMemories}
                onChange={handleChange}
                placeholder="在这里输入文字..."
                className="rpg-textarea"
                rows="6"
                required
              ></textarea>
            </div>
            <div className="form-group">
              <label>为什么希望成为游戏博物馆的档案员？</label>
              <textarea
                name="motivation"
                value={formData.motivation}
                onChange={handleChange}
                placeholder="在这里输入文字..."
                className="rpg-textarea"
                rows="6"
                required
              ></textarea>
            </div>
            <div className="form-group">
              <label>有什么更多想告诉我们的吗（可选）</label>
              <textarea
                name="additionalInfo"
                value={formData.additionalInfo}
                onChange={handleChange}
                placeholder="在这里输入文字..."
                className="rpg-textarea"
                rows="4"
              ></textarea>
            </div>
          </div>
        );
      
      case 4:
        return (
          <div className="character-creation-step">
            <h2 className="step-title">技能与经验</h2>
            <div className="skills-sliders">
              <div className="skill-slider-group">
                <div className="skill-question">Photoshop, GIMP, Canva等图片编辑工具</div>
                <div className="slider-container">
                  <input
                    type="range"
                    name="photoshopSkill"
                    min="0"
                    max="4"
                    value={formData.photoshopSkill}
                    onChange={handleChange}
                    className="rpg-slider"
                  />
                  <div className="slider-value">{skillLevelLabels.photoshop[formData.photoshopSkill]}</div>
                </div>
              </div>
              
              <div className="skill-slider-group">
                <div className="skill-question">英语水平</div>
                <div className="slider-container">
                  <input
                    type="range"
                    name="englishSkill"
                    min="0"
                    max="4"
                    value={formData.englishSkill}
                    onChange={handleChange}
                    className="rpg-slider"
                  />
                  <div className="slider-value">{skillLevelLabels.english[formData.englishSkill]}</div>
                </div>
              </div>
              
              <div className="skill-slider-group">
                <div className="skill-question">日语水平</div>
                <div className="slider-container">
                  <input
                    type="range"
                    name="japaneseSkill"
                    min="0"
                    max="4"
                    value={formData.japaneseSkill}
                    onChange={handleChange}
                    className="rpg-slider"
                  />
                  <div className="slider-value">{skillLevelLabels.japanese[formData.japaneseSkill]}</div>
                </div>
              </div>
              
              <div className="skill-slider-group">
                <div className="skill-question">英文互联网的使用习惯</div>
                <div className="slider-container">
                  <input
                    type="range"
                    name="englishInternetHabit"
                    min="0"
                    max="4"
                    value={formData.englishInternetHabit}
                    onChange={handleChange}
                    className="rpg-slider"
                  />
                  <div className="slider-value">{skillLevelLabels.internet[formData.englishInternetHabit]}</div>
                </div>
              </div>
              
              <div className="skill-slider-group">
                <div className="skill-question">用模拟器运行老游戏的经历</div>
                <div className="slider-container">
                  <input
                    type="range"
                    name="emulatorExperience"
                    min="0"
                    max="4"
                    value={formData.emulatorExperience}
                    onChange={handleChange}
                    className="rpg-slider"
                  />
                  <div className="slider-value">{skillLevelLabels.emulator[formData.emulatorExperience]}</div>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 5:
        return (
          <div className="character-creation-step">
            <h2 className="step-title">确认信息</h2>
            <p className="confirmation-notice">请仔细检查以下信息，确认无误后提交申请</p>
            <div className="confirmation-summary">
              <div className="summary-section">
                <h3>基本信息</h3>
                <div className="summary-grid">
                  <div className="summary-row">
                    <span className="summary-label">姓名</span>
                    <span className="summary-content">{formData.name}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">微信/手机</span>
                    <span className="summary-content">{formData.wechat || '未填写'}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">邮箱</span>
                    <span className="summary-content">{formData.email}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">年龄</span>
                    <span className="summary-content">{formData.age}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">状态</span>
                    <span className="summary-content">
                      {formData.status === 'student' ? '学生' : formData.status === 'working' ? '在职' : formData.statusDescription || '其他'}
                    </span>
                  </div>
                  {formData.workplace && (
                    <div className="summary-row">
                      <span className="summary-label">所在地</span>
                      <span className="summary-content">{formData.workplace}</span>
                    </div>
                  )}
                  <div className="summary-row">
                    <span className="summary-label">意向投入时间</span>
                    <span className="summary-content">{formData.hoursPerWeek} 小时/周</span>
                  </div>
                </div>
              </div>
              
              <div className="summary-section">
                <h3>关于你与游戏</h3>
                <div className="summary-text-block">
                  <div className="summary-text-item">
                    <div className="summary-text-label">游戏回忆</div>
                    <div className="summary-text-content">{formData.gameMemories}</div>
                  </div>
                  <div className="summary-text-item">
                    <div className="summary-text-label">加入动机</div>
                    <div className="summary-text-content">{formData.motivation}</div>
                  </div>
                  {formData.additionalInfo && (
                    <div className="summary-text-item">
                      <div className="summary-text-label">其他信息</div>
                      <div className="summary-text-content">{formData.additionalInfo}</div>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="summary-section">
                <h3>技能与经验</h3>
                <div className="summary-grid">
                  <div className="summary-row">
                    <span className="summary-label">图片编辑工具</span>
                    <span className="summary-content">{skillLevelLabels.photoshop[formData.photoshopSkill]}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">英语水平</span>
                    <span className="summary-content">{skillLevelLabels.english[formData.englishSkill]}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">日语水平</span>
                    <span className="summary-content">{skillLevelLabels.japanese[formData.japaneseSkill]}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">英文互联网使用</span>
                    <span className="summary-content">{skillLevelLabels.internet[formData.englishInternetHabit]}</span>
                  </div>
                  <div className="summary-row">
                    <span className="summary-label">模拟器经验</span>
                    <span className="summary-content">{skillLevelLabels.emulator[formData.emulatorExperience]}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 6:
        return (
          <div className="character-creation-step">
            <div className="success-message">
              <h2>申请成功！</h2>
              <div className="success-icon"></div>
              <p>感谢你的申请！我们会尽快审核并与你联系。</p>
              <p>准备好开始你在游戏博物馆的冒险了吗？</p>
              <Link to="/" className="return-home-btn">返回首页</Link>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };
  
  return (
    <div className="enlist-wrapper">
      <Navbar />
      
      <div className="enlist-container">
        <h1 className="enlist-title">加入我们</h1>
        
        <div className="character-creation-container">
          <div className="progress-tracker">
            {[0, 1, 2, 3, 4, 5, 6].map((step) => (
              <div 
                key={step}
                className={`progress-step ${currentStep === step ? 'current' : currentStep > step ? 'completed' : ''}`}
              >
                <div className="step-number">{step === 0 ? '0' : step === 6 ? '✓' : step}</div>
                <div className="step-name">
                  {step === 0 ? '关于我们' :
                   step === 1 ? '基本信息' :
                   step === 2 ? '状态与时间' :
                   step === 3 ? '关于游戏' :
                   step === 4 ? '技能经验' :
                   step === 5 ? '确认信息' :
                   '完成'
                  }
                </div>
              </div>
            ))}
          </div>
          
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="character-creation-form">
              {renderStep()}
            </div>
            
            {currentStep < 6 && (
              <div className="form-actions">
                {currentStep > 0 && currentStep < 6 && (
                  <button
                    type="button"
                    className="prev-btn"
                    onClick={prevStep}
                  >
                    上一步
                  </button>
                )}
                
                {currentStep === 0 && (
                  <button
                    type="button"
                    className="next-btn mission-start-btn"
                    onClick={nextStep}
                  >
                    开始申请
                  </button>
                )}
                
                {currentStep > 0 && currentStep < 5 && (
                  <button
                    type="button"
                    className={`next-btn ${!isStepComplete() ? 'disabled' : ''}`}
                    onClick={nextStep}
                    disabled={!isStepComplete()}
                  >
                    下一步
                  </button>
                )}
                
                {currentStep === 5 && (
                  <button
                    type="button"
                    className="confirm-btn"
                    onClick={handleSubmit}
                  >
                    提交申请
                  </button>
                )}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Enlist; 